import React from "react";
import Typography from "@mui/material/Typography";
import { InvoiceStatus } from "../models/ChasableModels";
import OverdueCalculationComponent from "./OverdueCalculationComponent";
import { getSeverityColor } from "../services/helpers";
import { useTheme } from "@mui/material/styles";
import { Chip } from "@mui/material";

type Props = {
  invoice: { status: InvoiceStatus; dueDate: string };
  color?: string;
  component?: React.ElementType;
};

export function InvoiceStatusComponent({ invoice, color, component = "p" }: Props) {
  const theme = useTheme();
  const isDarkMode = theme.palette.mode === "dark";

  const chipStyles = {
    borderRadius: "4px",
    p: 0,
    height: "unset",
    color: "common.white",
    "& .MuiChip-label": { px: "4px", py: "0" },
  };

  if (invoice.status === InvoiceStatus.PAID) {
    return (
      <Chip
        size="small"
        sx={{ ...chipStyles, backgroundColor: isDarkMode ? theme.palette.success.main : getSeverityColor("success") }}
        label={
          <Typography variant="body1" component={component} color="inherit" fontSize={12} fontWeight={400}>
            Paid
          </Typography>
        }
        color="success"
      />
    );
  }

  if (invoice.status === InvoiceStatus.DRAFT) {
    return (
      <Chip
        size="small"
        sx={{ ...chipStyles, backgroundColor: "grey.400" }}
        label={
          <Typography variant="body1" component={component} color="inherit" fontSize={12} fontWeight={400}>
            Draft
          </Typography>
        }
        color="default"
      />
    );
  }

  return <OverdueCalculationComponent dueDate={new Date(invoice.dueDate)} color={color} component={component} />;
}
